// src/api/resourceApi.js
import { v4 as uuidv4 } from 'uuid';

const localStorageKey = 'resources';

// Dummy data for initial setup
const getInitialResources = () => {
    return [
        { id: 'res-1', name: 'Software Developer', description: 'Skilled in React and Node.js' },
        { id: 'res-2', name: 'UI/UX Designer', description: 'Creates wireframes and prototypes' },
        { id: 'res-3', name: 'Project Manager', description: 'Oversees project timelines and budgets' },
    ];
};

// Check if resources exist in localStorage, otherwise initialize with dummy data
if (!localStorage.getItem(localStorageKey)) {
    localStorage.setItem(localStorageKey, JSON.stringify(getInitialResources()));
}

// Function to fetch all resources
export const getResources = () => {
    return new Promise(resolve => {
        setTimeout(() => {
            const resources = JSON.parse(localStorage.getItem(localStorageKey)) || [];
            resolve(resources);
        }, 500);
    });
};

// Function to add a new resource
export const addResource = (resource) => {
    return new Promise(resolve => {
        setTimeout(() => {
            const resources = JSON.parse(localStorage.getItem(localStorageKey)) || [];
            const newResource = { ...resource, id: uuidv4() };
            resources.push(newResource);
            localStorage.setItem(localStorageKey, JSON.stringify(resources));
            resolve(newResource);
        }, 500);
    });
};

// Function to update an existing resource
export const updateResource = (id, updatedResource) => {
    return new Promise(resolve => {
        setTimeout(() => {
            let resources = JSON.parse(localStorage.getItem(localStorageKey)) || [];
            resources = resources.map(res =>
                res.id === id ? { ...res, ...updatedResource } : res
            );
            localStorage.setItem(localStorageKey, JSON.stringify(resources));
            resolve(updatedResource);
        }, 500);
    });
};

// Function to delete a resource
export const deleteResource = (id) => {
    return new Promise(resolve => {
        setTimeout(() => {
            let resources = JSON.parse(localStorage.getItem(localStorageKey)) || [];
            resources = resources.filter(res => res.id !== id);
            localStorage.setItem(localStorageKey, JSON.stringify(resources));
            resolve({ success: true });
        }, 500);
    });
};
